import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/authService';
import ArthLogo from '../assets/logo.png';

const ResetPassword: React.FC = () => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleResetPassword = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (newPassword !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    if (newPassword.length < 8) {
      setError('Password must be at least 8 characters long');
      return;
    }

    const params = new URLSearchParams(window.location.search);
    const uid = params.get('uid');
    const token = params.get('token');

    if (!uid || !token) {
      setError('Invalid or missing parameters in reset link.');
      return;
    }

    setLoading(true);
    try {
      await authService.confirmResetPassword(uid, token, newPassword);
      setSuccess('Your password has been reset successfully. Redirecting to sign in...');
      setTimeout(() => {
        navigate('/');
      }, 3000);
    } catch (err: any) {
      setError(err.message || 'Failed to reset password. The link may have expired.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-split-layout">
      <div className="login-visual-panel">
        <div className="parallax-layer" style={{ width: '100%', height: '100%', position: 'absolute', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div className="logo-container">
            <img src={ArthLogo} alt="Logo" style={{ width: '100px' }} />
          </div>
          <div className="login-visual-content" style={{ zIndex: 10, position: 'absolute', bottom: '10%', textAlign: 'center', width: '100%' }}>
            <p style={{ marginTop: '0.5rem', fontSize: '1.125rem', color: 'var(--primary-light)', margin: 0 }}>&copy; {new Date().getFullYear()} ARTH</p>
          </div>
        </div>
      </div>
      <div className="login-form-panel">
        <h2>Reset Password</h2>
        <p>Please enter your new password below</p>

        <form onSubmit={handleResetPassword} style={{ width: '100%', maxWidth: '400px', margin: '0 auto' }}>
          {error && <div style={{ color: 'red', marginBottom: '1rem', textAlign: 'center', backgroundColor: '#fee2e2', padding: '0.5rem', borderRadius: '4px', fontSize: '0.85rem' }}>{error}</div>}
          {success && <div style={{ color: '#15803d', marginBottom: '1rem', textAlign: 'center', backgroundColor: '#dcfce7', padding: '0.5rem', borderRadius: '4px', fontSize: '0.85rem' }}>{success}</div>}

          <div className="floating-input-group">
            <input
              type="password"
              id="new-password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder=" "
              required
              disabled={loading}
            />
            <label htmlFor="new-password">New Password</label>
          </div>

          <div className="floating-input-group">
            <input
              type="password"
              id="confirm-password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder=" "
              required
              disabled={loading}
            />
            <label htmlFor="confirm-password">Confirm Password</label>
          </div>

          <button type="submit" className="primary-btn" disabled={loading} style={{ width: '100%', justifyContent: 'center' }}>
            <span>{loading ? 'Resetting...' : 'Reset Password'}</span>
          </button>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
